"use strict";
exports.__esModule = true;
exports.CONTINENT_CODES = void 0;
exports.CONTINENT_CODES = ['AF', 'NA', 'OC', 'AN', 'AS', 'EU', 'SA'];
//# sourceMappingURL=continent-codes.constant.js.map